import { ReportResponseResource } from "@models/resource/report-response.resource";
import { ResponsivenessState, ReviewDocumentState, ReviewDocumentStatusType } from "@models/ui/case-analytics-state/review-document-state.model";
import { MapperBase } from "@utilities/mapper-base";

export class ReportResponseResourceToResponsivenessReviewDocumentStateMapper extends MapperBase<ReportResponseResource, ReviewDocumentState> {
    map(source: ReportResponseResource): ReviewDocumentState {
        const dest = new ReviewDocumentState();
        let sum = 0;
        dest.responsivenessStates = source?.data
        .filter(item => ReportLabelToResponsivenessStatusTypeMap.has(item?.pivot))
        .map((item) => {
            const state = new ResponsivenessState();
            state.status = ReportLabelToResponsivenessStatusTypeMap.get(item?.pivot);
            state.statusCount = Number(item?.total);
            sum += state.statusCount;
            return state;
        });
        dest.totalDocCount = sum;
        return dest;
    }
}
export const ReportLabelToResponsivenessStatusTypeMap: Map<string, ReviewDocumentStatusType> = new Map([
    ['Responsive', 'Responsive'],
    ['Non-Responsive', 'Non Responsive'],
    ['Blank', 'Not Specified'],
    ['Needs Further Review', 'Needs Further Review']
]);